export const udlTypes = {
  engagement: 1,
  representation: 2,
  actionAndExpression: 3
}
